import { Identifiable, Resource, RetrieveWorkLoadsFilter } from "@planzone/dto";

function matchResources(
  first: Identifiable<Resource>[],
  second: Identifiable<Resource>[],
) {
  const uniqueIds = new Set([
    ...first.map(({ uuid }) => uuid),
    ...second.map(({ uuid }) => uuid),
  ]);

  return uniqueIds.size === first.length && uniqueIds.size === second.length;
}

function match(
  first: RetrieveWorkLoadsFilter,
  second: RetrieveWorkLoadsFilter,
) {
  return (
    first.endDate === second.endDate &&
    first.startDate === second.startDate &&
    first.view === second.view &&
    (first.resources && second.resources
      ? matchResources(first.resources, second.resources)
      : true)
  );
}

export { match };
